﻿import { MdSlider } from '@material/web/all';

class RemoveFilter extends HTMLElement {
  connectedCallback() {
    const targetsAttribute = this.getAttribute('data-targets').split(',');
    const targets = targetsAttribute.map((item: string) => {
      return document.getElementsByName(item);
    });

    let value = this.getAttribute('target-value');

    this.firstElementChild.addEventListener('click', (e) => {
      targets.forEach((array) => {
        array.forEach((item) => {
          if (item.tagName == 'SELECT') {
            const select = item as HTMLSelectElement;
            select.selectedIndex = 0;
          }
          if (item.tagName == 'INPUT') {
            const input = item as HTMLInputElement;
            if (input.type == 'radio' && input.value == value) {
              input.checked = false;
            }
            if (input.type == 'text') {
              input.value = '';
            }
            if (input.type == 'range') {
              var index = Array.from(input.parentNode.children).indexOf(input);
              var resetValue = index == 0 ? input.min : input.max;
              input.value = resetValue;
            }
          }
        });
      });
      setTimeout(() => this.closest('form').requestSubmit(), 120); // set timout
    });
  }
}

customElements.define('remove-filter', RemoveFilter);
